import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { GestionNaComponent } from '../../../../core/gestion-referentiel/gestion-na/gestion-na.component';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { TypeCompModel } from 'src/app/shared/models/simple-types/type-comp.model';

export interface DialogData {
    form: UntypedFormGroup;
    nas: NaModel[];
    cgCharges: CgChargeModel[];
    typeComps: TypeCompModel[];
    result: boolean;
  }
@Component({
    selector: 'app-modal-add-na',
    templateUrl: './modal-add-na.component.html',
    styleUrls: ['./modal-add-na.component.scss']
  })
  export class ModalAddNaComponent implements OnInit {
    nas: NaModel[];
    form: UntypedFormGroup;
    cgCharge: CgChargeModel;
    typeComp: TypeCompModel;
    constructor(public dialog: MatDialog
              , public dialogRef: MatDialogRef<GestionNaComponent>
              , @Inject(MAT_DIALOG_DATA) public data: DialogData
              , private toastr: ToastrService
              , private naService: NaService) {
               }

  ngOnInit(): void {
    this.nas = this.data.nas;
    this.form = this.data.form;
    if (this.form) {
      this.cgCharge = this.data.cgCharges.find(s => s.code === this.form.get('cgCharge').value);
      this.typeComp = this.data.typeComps.find(s => s.code === this.form.get('typeComp').value);
    }
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const na = this.form.getRawValue();
      this.cgCharge ? na.cgCharge = this.cgCharge.code : na.cgCharge = '';
      this.typeComp ? na.typeComp = this.typeComp.code : na.typeComp = '';

      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.naService.save(na).subscribe((a: NaModel) => {
            this.toastr.success('', 'Création de la nature analytique ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.naService.update(na.id, na).subscribe((a: NaModel) => {
          this.toastr.success('', 'Modification de la nature analytique ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
      this.toastr.warning('', 'Veuillez remplir les champs obligatoire');
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}

